const CONSTANTS = {
    api_server:'https://www.siop-authcode-api.demos.zedeid.com'
    // api_server: 'https://06e9-112-134-225-31.ngrok.io'
};
export default CONSTANTS;
